import React, { useState } from 'react';
import {Typography, Paper, Stack, Grid} from '@mui/material';
import ManageInternetPackage from './ManageInternetPackage';
import BillingInformation from './BillingInformation';
import ChooseInternetPackage from './ChooseInternetPackage';
import {PropertyWithRelations, useGetInternetSubscriptionsActiveQuery} from "../../../redux/residentPortalApi";

interface OwnProps {
  property: PropertyWithRelations;
}


const WifiSection: React.FC<OwnProps> = ({property}) => {
  const propertyId = property?.id || '';
  const { data: activeSubResp, isLoading: activeLoading } = useGetInternetSubscriptionsActiveQuery({ propertyId }, { skip: !propertyId });
  const hasActiveSubscription = Boolean(activeSubResp?.subscription);

  const view: 'choose' | 'manage' = hasActiveSubscription ? 'manage' : 'choose';
  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        borderRadius: 2,
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        mb: 4
      }}
    >
      <Stack spacing={3}>
        <Typography variant="h2" sx={{
          fontSize: '1.75rem',
          fontWeight: 600,
          color: '#1976d2',
          mb: 2,
          borderBottom: '2px solid #e0e0e0',
          paddingBottom: 1
        }}>
          Internet & WiFi
        </Typography>

        {view === 'choose' ? (
          <ChooseInternetPackage propertyId={property.id || ''} />
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              {property.id && activeSubResp?.package && (
                <ManageInternetPackage propertyId={property.id} internetPackage={activeSubResp.package as any} />
              )}
            </Grid>
            <Grid item xs={12} md={8}>
              {property.id && <BillingInformation propertyId={property.id} property={property} />}
            </Grid>
          </Grid>
        )}

      </Stack>
    </Paper>
  );
};

export default WifiSection;
